import React from "react";

/**
 * The usage screens' loading block — the same paint as
 * `@/components/shared/Skeleton`, in the card radius the tiles below use.
 *
 * The headline band built from these is `UsageStatBandSkeleton`.
 */
const UsageSkeleton = ({ className = "" }) => <span className={`block animate-pulse rounded-xl bg-background-tertiary ${className}`} />;

export default UsageSkeleton;
